const o = {
  name: "ArrowDiagonalDownSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.4142 8.00015L10.4142 15.0002L15 15.0002L15 17.0002L7 17.0002L7 9.00015L9 9.00015L9 13.5859L16 6.58594L17.4142 8.00015Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ArrowDiagonalDownSmall
};
